/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Stringcontainsnoneaspect14Inputs */



/**

* @param {_Filter_Class_Stringcontainsnoneaspect14Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_stringcontainsnoneaspect14 = /** @type {((inputs?: _Filter_Class_Stringcontainsnoneaspect14Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Stringcontainsnoneaspect14Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("beinhaltet keines von")
});
export { _filter_class_stringcontainsnoneaspect14 as "_filter_class_StringCONTAINSNONEAspect" }